import { Drawer, DrawerContent, type DrawerProps } from "@heroui/react";
import { type ReactNode, type FC, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import { Title } from "./Title";

interface DrawerWrapperProps {
  children?: ReactNode;
  title?: string;
  titleClassName?: string;
  baseClassName?: string;
}

export const DrawerWrapper: FC<DrawerWrapperProps & DrawerProps> = ({
  children,
  title,
  titleClassName,
  baseClassName,
  classNames,
  ...props
}) => {
  const [bottomHeight, setBottomHeight] = useState(0);

  useEffect(() => {
    let onViewportChange: () => void;

    if (window.visualViewport) {
      const viewport = window.visualViewport;

      onViewportChange = () => {
        const offsetBottom = viewport.height - window.innerHeight;
        setBottomHeight(Math.abs(offsetBottom));
      };

      viewport.addEventListener("resize", onViewportChange);
      viewport.addEventListener("scroll", onViewportChange);
    }

    return () => {
      if (window.visualViewport) {
        const viewport = window.visualViewport;
        viewport.removeEventListener("resize", onViewportChange);
        viewport.removeEventListener("scroll", onViewportChange);
      }
    };
  }, []);

  return (
    <Drawer
      portalContainer={document.body.querySelector("#root")!}
      placement="bottom"
      classNames={{
        backdrop: twMerge("bg-[rgba(0,0,0,0.75)]", classNames?.backdrop),
        wrapper: twMerge(
          "fixed min-h-[100vh] min-h-[100dvh]",
          classNames?.wrapper,
        ),
        base: twMerge(
          "max-h-[90vh] max-h-[90dvh]",
          baseClassName,
          classNames?.base,
        ),
      }}
      hideCloseButton={true}
      {...props}
    >
      <DrawerContent>
        {() => (
          <div
            className="flex h-full flex-col overflow-hidden pt-3"
            style={{ paddingBottom: bottomHeight }}
          >
            {title ? (
              <Title
                title={title}
                className={twMerge("my-6", titleClassName)}
              />
            ) : null}
            <div className="flex flex-1 flex-col overflow-y-auto">
              {children}
            </div>
          </div>
        )}
      </DrawerContent>
    </Drawer>
  );
};
